import { gql } from '@apollo/client';

export const signup = gql`
  mutation signup($signupParams: SignupParams!) {
    signup(signupParams: $signupParams) {
      tokenSet {
        access_token
        expires_in
        id_token
      }
      alterError {
        data
        errorCode
        message
      }
    }
  }
`;
